import { Outlet } from "react-router";
import CleComplianceProvider from "./providers/AppProvider";
import MainLayout from "./layouts/MainLayout";

export default function CleComplianceApp() {
  return (
    <CleComplianceProvider>
      <MainLayout>
        <Outlet />
      </MainLayout>
    </CleComplianceProvider>
  );
}
